import React, { useState, useEffect, useContext } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  TextField,
  AppBar,
  Tabs,
  Tab,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Hidden,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  OutlinedInput,
  CircularProgress,
  FormLabel,
  Checkbox,
} from "@material-ui/core";
import useResizer from "../../services/useResizer";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

import { format } from "date-fns";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory } from "react-router-dom";
import InfoIcon from "@material-ui/icons/Info";
import { iconsDict } from "../../assets/icons/iconsDict.js";
import EmptyTransparentCard from "../../components/StaticComp/EmptyTransparentCard/EmptyTransparentCard";
import SingleItem from "../../components/StaticComp/LandingPageFeature/LandingPageFeature";
import Icon from "../../fontIcons/icon";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { REACT_APP_PROD_URL } from "../../services/configs";
import * as Sentry from "@sentry/react";
import DeleteIcon from "@material-ui/icons/Delete";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import extraStyles from "./lend.module.css";
import { CoinContext } from "../../contexts/CoinContext";
import loaderGif from "../../assets/img/loader.gif";
import { RiSafe2Fill } from "react-icons/ri";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useSelector } from "react-redux";

import { useMutation, useQuery } from "react-query";
import fetcher from "../../api/swr_fetcher.js";
import LoginOrCreateAccount from "../../components/LoginOrCreateAccount";
import { useDialog } from "../../contexts/DialogProvider";
import CoinDetailStrip from "../../components/CoinDetailStrip";
import RateCard from "../../components/RateCard";

import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.scss"; // core Swiper
import "swiper/modules/navigation/navigation.scss"; // Navigation module
import "swiper/modules/pagination/pagination.scss"; // Pagination module
import { indexOf } from "lodash";
import { Value } from "sass";

SwiperCore.use([Navigation, Autoplay, Pagination, EffectFade]);

const InfoText = (props) => {
  const { label, value, declining, growth } = props;
  const classes = useStyles();
  return (
    <div className={classes.highlow}>
      <Typography
        variant="body2"
        display="block"
        className={classes.infoHeaderStyles}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        display="block"
        className={
          declining
            ? classes.declineStyles
            : growth
            ? classes.growthStyles
            : classes.defaultStyles
        }
      >
        {value}
      </Typography>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Lend() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const token = useSelector((state) => state.trading.TOKEN);
  const isMobile = useResizer();
  const [tabValue, setTabValue] = useState(0);
  const [mobileTabValue, setMobileTabValue] = useState(0);
  const [amount, setAmount] = useState(null);
  const [months, setMonths] = useState("ONE_YEAR");
  const [doubleClick, setDoubleClick] = useState(false);
  const [historyV, setHistoryV] = useState(null);
  const [hVaults, setHVaults] = useState([]);
  const [page, setPage] = useState(0);
  const [openDialogHelp, setDialogHelp] = useState(false);

  //Rahul's changes
  const [openDialog, closeDialog] = useDialog();
  const [currentCoin, setCurrentCoin] = useState(null);
  const [filteredCoinData, setFilteredCoinData] = useState({});
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);
  const [currentScreenMobile, setCurrentScreenMobile] =
    useState("CREATE_VAULT");
  const [errorFields, setErrorFields] = useState({
    amt: false,
  });
  const [coinKeys, setCoinKeys] = useState([]);
  const settings = {
    shortSwipes: false,
    freeMode: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
      },
      // when window width is >= 640px
      1366: {
        slidesPerView: 3,
      },
    },
    preloadImages: true,
    centered: true,
    paginationClickable: true,
    // loop: true,
    direction: "horizontal",
    speed: 1000,

    initialSlide: 0,
    allowTouchMove: true,
    touchEventsTarget: "wrapper",
    centerInsufficientSlides: true,
  };

  const coinHolderSettings = {
    zoom: true,
    watchOverflow: true,
    shortSwipes: false,
    freeMode: true,
    centerInsufficientSlides: true,

    freeModeMomentum: false,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 3,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 4,
      },
      // when window width is >= 640px
    },
    preloadImages: true,
    centered: true,
    paginationClickable: true,
    // loop: true,
    direction: "horizontal",
    speed: 1000,
    initialSlide: 0,
    allowTouchMove: true,
    touchEventsTarget: "wrapper",
  };

  const { handleClickAlert } = useContext(CoinContext);

  const dictMonth = {
    ONE_WEEK: "1 Week Vault",
    ONE_MONTH: "1 Month Vault",
    THREE_MONTHS: "3 Months Vault",
    SIX_MONTHS: "6 Months Vault",
    ONE_YEAR: "1 Year Vault",
  };

  const mobileScreens = [
    { id: "CREATE_VAULT", text: "Create Vault" },
    { id: "MY_VAULTS", text: "My Vaults" },
    { id: "FAQS", text: "FAQs" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleDialogOpen = () => {
    setDialogHelp(true);
  };

  const handleDialogClose = () => {
    setDialogHelp(false);
  };

  function loadMore() {
    if (historyV) {
      if (page < historyV.totalPages - 1) {
        setPage(page + 1);
      }
    }
  }

  function toPlainString(num) {
    return ("" + +num).replace(
      /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
      function (a, b, c, d, e) {
        return e < 0
          ? b + "0." + Array(1 - e - c.length).join(0) + c + d
          : b + c + d + Array(e - d.length + 1).join(0);
      },
    );
  }
  const lockInVaultConfirmationDialog = (coinId, principal, tenure, apy) =>
    openDialog({
      children: (
        <>
          <DialogTitle>Confirmation</DialogTitle>
          <form
            required
            component="fieldset"
            className={classes.formControl}
            onSubmit={(e) => {
              e.preventDefault();
              lockInVaultButtonClick(coinId, principal, tenure);
              closeDialog();
            }}
          >
            <DialogContent>
              <Typography>
                You are locking{" "}
                <span
                  style={{
                    color: theme.palette.primary.main,
                    wordBreak: "break-all",
                  }}
                >
                  {amount}
                </span>{" "}
                {currentCoin} for {dictMonth[months].replace("Vault", "")}
                and you will get{" "}
                <Tooltip
                  className="cursor-pointer"
                  title={interest}
                  placement="top"
                  enterTouchDelay={0}
                  arrow
                >
                  <span
                    style={{
                      color: theme.palette.primary.main,
                    }}
                  >
                    {truncate(interest)}
                  </span>
                </Tooltip>{" "}
                {currentCoin} as interest with an annual percentage yield of{" "}
                <span style={{ color: theme.palette.primary.main }}>
                  {
                    filteredCoinData?.[currentCoin]?.["lendData"]?.find(
                      (ele) => ele.tenure === months,
                    )?.rate
                  }
                  %.
                </span>{" "}
              </Typography>
              <br></br>
              <div className="w-full">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="first"
                        required
                        color="primary"
                        // style={{
                        //   color: "#3AC4AB",
                        // }}
                      />
                    }
                    label={
                      <p className="text-sm md:text-base">
                        I agree to the T&C of PocketBits Earn
                      </p>
                    }
                  />
                  <br></br>
                  <FormControlLabel
                    style={{ display: "table" }}
                    control={
                      <div style={{ display: "table-cell" }}>
                        <Checkbox name="second" required color="primary" />
                      </div>
                    }
                    label={
                      <p className="text-sm md:text-base">
                        I understand that canceling the Vault before the tenure
                        ends would lead to a 0% interest and only the Principal
                        amount would return to my available balance.
                      </p>
                    }
                  />
                </FormGroup>
                <br></br>
              </div>
            </DialogContent>
            <DialogActions
              style={{ paddingBottom: "30px", paddingRight: "20px" }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  closeDialog();
                }}
                color="primary"
              >
                Cancel
              </Button>{" "}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Confirm Vault
              </Button>
            </DialogActions>{" "}
          </form>
        </>
      ),
    });

  const deleteVaultConfirmationDialog = (
    vaultId,
    principal,
    coinId,
    startDate,
  ) =>
    openDialog({
      children: (
        <div>
          <DialogTitle>Cancellation</DialogTitle>
          <form
            required
            component="fieldset"
            className={classes.formControl}
            onSubmit={(e) => {
              e.preventDefault();
              deleteVaultButtonClick(vaultId);
              closeDialog();
            }}
          >
            <DialogContent>
              <Typography>
                Are you sure that you want to cancel your Vault for{" "}
                <span className="font-bold text-pb-primary-100">
                  {principal} {coinId}
                </span>
                , started on{" "}
                <span className="font-bold text-pb-primary-100">
                  {startDate}
                </span>
                ?
              </Typography>
              <br></br>
              <div className="w-full">
                <FormGroup>
                  <FormControlLabel
                    style={{ display: "table" }}
                    control={
                      <div style={{ display: "table-cell" }}>
                        <Checkbox name="first" required color="primary" />
                      </div>
                    }
                    label={
                      <p className="text-sm md:text-base">
                        By canceling the Active Vault, I understand that I will
                        lose out on any accumulated interest and only my
                        Principal amount would be returned back to my available
                        balance.
                      </p>
                    }
                  />
                </FormGroup>
                <br></br>
              </div>
            </DialogContent>
            <DialogActions
              style={{ paddingBottom: "30px", paddingRight: "10px" }}
              className="flex flex-wrap md:flex-nowrap gap-y-3"
            >
              <Button
                variant="outlined"
                color="primary"
                type="submit"
                className="text-sm"
              >
                Yes, Cancel my vault. Interest does not interest me!
              </Button>{" "}
              <Button
                variant="contained"
                onClick={() => {
                  closeDialog();
                }}
                className="mb-4 ml-0 md:ml-2 md:mb-0 text-sm"
                color="primary"
                style={{ color: "white", fontWeight: "bold" }}
              >
                No, I want to continue smart earning
              </Button>
            </DialogActions>{" "}
          </form>
        </div>
      ),
    });

  useEffect(() => {
    if (page > 0) {
      getMoreHistory();
    }
  }, [page]);
  const lendRates = useQuery(
    ["lendRates"],
    () => fetcher("/v1/vaults/rates").then((res) => res),
    {
      onSuccess: (data) => {
        let rateArray = [];
        const filteredLendRates = data.reduce(function (acc, curr, idx) {
          const coinId = curr.coinId;

          // if (coinId == "USDT") {
          //   setCurrentCoin(coinId);
          // }
          if (acc[coinId]?.["lendData"]?.length > 0) {
            acc[coinId]["lendData"] = [...acc[coinId]["lendData"], curr];
            rateArray.push(curr.rate);
            acc[coinId]["lendData"].sort(function (a, b) {
              return b.tenureInDays - a.tenureInDays;
            });
          } else {
            acc[coinId] = {};
            acc[coinId]["lendData"] = [curr];
            rateArray.push(curr.rate);
          }
          // acc.push(temp);
          return acc;
        }, {});
        setFilteredCoinData(filteredLendRates);
      },
    },
  );
  useEffect(() => {
    if (filteredCoinData) {
      let array = [];

      Object.entries(filteredCoinData)?.forEach(([key, value]) => {
        let obj = {};
        obj[value?.lendData[0]?.tenure] = value?.lendData[0];
        array.push(obj);
      });

      let sortedArray = array.sort((a, b) => {
        return b.ONE_YEAR.rate - a.ONE_YEAR.rate;
      });
      let coins = {};
      sortedArray.forEach((item) => {
        coins[item.ONE_YEAR.coinId] = item.ONE_YEAR;
      });
      let sortedCoin = Object.keys(coins) || [];
      setCurrentCoin(sortedCoin[0] || "");
      setCoinKeys(sortedCoin);
    }
  }, [filteredCoinData]);
  const currentCoinBalance = useQuery(
    ["currentCoinBalance", currentCoin],
    () => fetcher(`/v1/balances/${currentCoin}`).then((res) => res),
    {
      enabled: Boolean(currentCoin),
    },
  );
  const vaultConfig = useQuery(["vaultConfig"], () =>
    fetcher(`/v1/vaults/vaultConfig`).then((res) => res),
  );

  const currentCoinVaultBalance = useQuery(
    ["currentCoinVaultBalance", currentCoin],
    () => fetcher(`/v1/vaults/total/${currentCoin}`).then((res) => res),
    {
      enabled: Boolean(currentCoin),
    },
  );

  const lendOrders = useQuery(["lendOrders"], () =>
    fetcher(`/v1/vaults`).then((res) => res),
  );

  const createVault = useMutation(["createVault"], (values) =>
    fetcher(`/v1/vaults`, {
      method: "POST",
      body: {
        ...values,
      },
    }).then((res) => res),
  );

  const deleteVault = useMutation(["createVault"], ({ vaultId }) =>
    fetcher(`/v1/vaults/${vaultId}`, {
      method: "DELETE",
    }).then((res) => res),
  );
  useEffect(() => {
    setMonths("ONE_YEAR");
    setAmount("");
    handleHistory();
  }, [currentCoin]);

  async function lockInVaultButtonClick(coinId, principal, tenure) {
    try {
      await createVault.mutateAsync({ coinId, principal, tenure });
      handleClickAlert("success", "Vault created successfully!");
      currentCoinVaultBalance.refetch();
      currentCoinBalance.refetch();
      lendOrders.refetch();
      setAmount("");
    } catch (e) {
      let readableError = e.info?.detail?.match(/"([^']+)"/)[1];
      handleClickAlert("error", readableError);
    }
  }

  async function deleteVaultButtonClick(vaultId) {
    try {
      await deleteVault.mutateAsync({ vaultId });
      handleClickAlert("success", "Vault cancelled successfully!");
      currentCoinVaultBalance.refetch();
      currentCoinBalance.refetch();
      lendOrders.refetch();
      handleHistory();
    } catch (e) {
      let readableError = e.info?.detail?.match(/"([^']+)"/)[1];
      handleClickAlert("error", readableError);
    }
  }

  function handleHistory() {
    fetcher(`/v1/vaults/history?page=1&sortBy=createdAt&pageSize=5`)
      .then((data) => {
        setHistoryV(data);
        setHVaults(data.content);
      })
      .catch((err) => {
        // console.log(err);
        Sentry.captureException(err);
      });
  }

  function getMoreHistory() {
    fetcher(`/v1/vaults/history?page=${page + 1}&sortBy=createdAt&pageSize=5`)
      .then((data) => {
        setHistoryV(data);
        setHVaults((prevOrders) => {
          return [...prevOrders, ...data.content];
        });
      })
      .catch((err) => {
        // console.log(err);
        Sentry.captureException(err);
      });
  }

  function handleCoinClick(coin) {
    setCurrentCoin(coin);
  }
  function handleMonths(month) {
    setMonths(month);
  }

  const Arrow = ({ text, className }) => {
    return (
      <div className={classes.arrow}>
        <IconButton
          className={className}
          style={{
            // paddingLeft: "20px",
            // paddingRight: "20px",
            // paddingTop: "105px",
            // paddingBottom: "85px",
            margin: "5px",
          }}
        >
          {text}
        </IconButton>
      </div>
    );
  };

  const ArrowLeft = Arrow({
    text: <ArrowBackIosIcon />,
    className: "arrow-prev",
  });
  const ArrowRight = Arrow({
    text: <ArrowForwardIosIcon />,
    className: "arrow-next",
  });

  const minAmount = Number(
    vaultConfig.data?.find((ele) => ele.coinId == currentCoin)?.minAmount || 0,
  );
  const maxAmount =
    vaultConfig.data?.find((ele) => ele.coinId == currentCoin)?.maxAmount >
    Number(currentCoinBalance?.data?.[0]?.availableBalance || 0)
      ? Number(currentCoinBalance?.data?.[0]?.availableBalance || 0)
      : Number(
          vaultConfig.data?.find((ele) => ele.coinId == currentCoin)?.maxAmount,
        );
  const truncate = (input) =>
    input.length > 5 ? `${input.substring(0, 7)}...` : input;

  let interest = toPlainString(
    amount *
      Math.pow(
        1 +
          filteredCoinData?.[currentCoin]?.["lendData"]?.find(
            (ele) => ele.tenure === months,
          )?.ratePerDay,
        filteredCoinData?.[currentCoin]?.["lendData"]?.find(
          (ele) => ele.tenure === months,
        )?.tenureInDays,
      ) -
      amount,
  );

  return (
    <div style={{ fontFamily: "Gordita !important", marginTop: "-20px" }}>
      <div className={`${classes.leftCard}  `}>
        <div className={`${classes.vaultCoin} h-[450px] 2xl:h-[433px]`}>
          {lendRates.isSuccess ? (
            <>
              <h1
                className={`text-[16px] font-black text-[#E0E0E0]  pt-5 pl-7 pb-4 `}
              >
                Vault Assets
              </h1>
              <div className="w-full h-[1px] bg-[#ffffff0d]"></div>
              <div
                className={`w-full h-[388px] 2xl:h-[368px] overflow-y-auto ${extraStyles.scroll}`}
              >
                {coinKeys.length &&
                  coinKeys.map((item, i, arr) => {
                    return (
                      <RateCard
                        item={item}
                        i={i}
                        months={months}
                        filteredCoinData={filteredCoinData}
                        currentCoin={currentCoin}
                        coinIcons={coinIcons}
                        dictMonth={dictMonth}
                        handleCoinClick={handleCoinClick}
                        handleMonths={handleMonths}
                        arr={arr}
                      />
                    );
                  })}
              </div>
            </>
          ) : (
            <div
              className="flex justify-center items-center h-full"
              // style={{ height: "100px" }}
            >
              <CircularProgress color="primary" />
            </div>
          )}{" "}
        </div>

        <div
          className="md:hidden flex items-center justify-center flex-wrap w-full "
          style={{ marginTop: "30px" }}
        >
          <Tabs
            classes={{ root: classes.tabRoot }}
            variant="fullWidth"
            value={mobileTabValue}
            onChange={(e, newValue) => {
              setMobileTabValue(newValue);
              let mobileScreen = mobileScreens[newValue].id;
              setCurrentScreenMobile(mobileScreen);
            }}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {mobileScreens.map((ele) => (
              <Tab label={ele.text} className="font-bold" />
            ))}
          </Tabs>
          {/* <Button
            key={ele.id}
            size="medium"
            style={{
              fontSize: "16px",
            }}
            variant="contained"
            disableElevation
            className={`bg-pb-primary-100 ${
              ele.id === currentScreenMobile && "bg-opacity-50"
            } text-white mr-3 font-bold normal-case mb-2`}
            onClick={() => {
              setCurrentScreenMobile(ele.id);
            }}
          >
            {ele.text}
          </Button> */}
        </div>
        <form
          className={` ${
            isMobile
              ? currentScreenMobile === "CREATE_VAULT"
                ? "block"
                : "hidden"
              : ""
          } md:block `}
          onSubmit={(e) => {
            e.preventDefault();
            if (!Boolean(token)) {
              openDialog({
                children: (
                  <>
                    <DialogTitle>
                      {"Please Login or SignUp to continue"}
                    </DialogTitle>
                    <DialogActions
                      style={{ paddingBottom: "30px", paddingRight: "20px" }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          history.push(`/login`);
                          closeDialog();
                        }}
                        style={{ color: "white", fontWeight: "bold" }}
                      >
                        Login
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          history.push(`/createacc`);
                          closeDialog();
                        }}
                        color="primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Create an Account
                      </Button>
                    </DialogActions>
                  </>
                ),
              });
            } else {
              if (amount > 0) {
                lockInVaultConfirmationDialog(
                  currentCoin,
                  amount,
                  months,
                  filteredCoinData?.[currentCoin]?.["lendData"]?.find(
                    (ele) => ele.tenure === months,
                  )?.rate,
                );
              } else {
                handleClickAlert("error", "Quantity cannot be zero!");
              }
            }
          }}
        >
          <div className={classes.vaultCard}>
            <div className={`${classes.dropBalance}`}>
              <div className=" flex flex-wrap mb-5 ">
                <FormControl size="small" className="mr-5 mb-2 md:mb-0">
                  <Select
                    disableUnderline
                    MenuProps={{
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    classes={{
                      root: classes.root,
                      icon: classes.icon,
                    }}
                    fullWidth
                    className={` shadow-lg dark:bg-[#383B42] bg-[#eee] px-3 pt-2 pb-1 rounded-md border-none font-bold  text-xs md:text-md`}
                    value={currentCoin}
                    onChange={(event) => {
                      setCurrentCoin(event.target.value);
                    }}
                  >
                    {Object.keys(filteredCoinData).map((ele, idx) => (
                      <MenuItem
                        value={ele}
                        style={{ minWidth: "80px !important" }}
                      >
                        <div className="flex items-center">
                          <div>
                            <img
                              src={coinIcons[ele]?.activeIconUrl}
                              height="auto"
                              width={18}
                              className="mr-2"
                              alt={ele}
                            />
                          </div>
                          <div className="mr-1">{coinIcons[ele]?.coinName}</div>{" "}
                          <div className="font-light">{ele}</div>
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl size="small" className="h-full">
                  <Select
                    fullWidth
                    disableUnderline
                    MenuProps={{
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    classes={{
                      root: classes.root,
                      icon: classes.icon,
                    }}
                    className={`shadow-lg dark:bg-[#383B42] bg-[#eee] px-3 py-2 rounded-md border-none font-bold text-xs md:text-md`}
                    value={months}
                    onChange={(event) => {
                      setMonths(event.target.value);
                    }}
                  >
                    {filteredCoinData[currentCoin]?.["lendData"].map((ele) => (
                      <MenuItem
                        value={ele.tenure}
                        style={{ minWidth: "80px !important" }}
                      >
                        {dictMonth[ele.tenure]?.replace("Vault", "")}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {Boolean(token) && (
                <Hidden smDown>
                  <div style={{ textAlign: "end" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <AccountBalanceWalletIcon
                        style={{
                          marginRight: "5px",
                          fontSize: 30,
                          color:
                            theme.palette.type === "dark"
                              ? "#C4C4C4"
                              : "#949494",
                        }}
                      />
                      <p>
                        {toPlainString(
                          Number(
                            currentCoinBalance?.data?.[0]?.availableBalance ||
                              0,
                          ),
                        )}{" "}
                        {currentCoin} Wallet Balance
                      </p>
                    </div>
                    <div
                      style={{
                        marginTop: "4px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <RiSafe2Fill
                        style={{
                          fontSize: 25,
                          marginRight: "5px",
                          color:
                            theme.palette.type === "dark"
                              ? "#C4C4C4"
                              : "#949494",
                        }}
                      />
                      <p>
                        {toPlainString(
                          Number(
                            currentCoinVaultBalance?.data?.totalAmount || 0,
                          ),
                        )}{" "}
                        {currentCoin} In Vault
                      </p>
                    </div>
                  </div>
                </Hidden>
              )}
            </div>
            {Boolean(token) && (
              <Hidden mdUp>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      justifyContent: "flex-end",
                    }}
                  >
                    <AccountBalanceWalletIcon
                      style={{
                        marginRight: "5px",
                        fontSize: 30,
                        color:
                          theme.palette.type === "dark" ? "#C4C4C4" : "#949494",
                      }}
                    />
                    <p>
                      {toPlainString(
                        Number(
                          currentCoinBalance?.data?.[0]?.availableBalance || 0,
                        ),
                      )}{" "}
                      {currentCoin} Wallet Balance
                    </p>
                  </div>
                  <div
                    style={{
                      marginTop: "4px",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <RiSafe2Fill
                      style={{
                        fontSize: 25,
                        marginRight: "5px",
                        color:
                          theme.palette.type === "dark" ? "#C4C4C4" : "#949494",
                      }}
                    />
                    <p>
                      {toPlainString(
                        currentCoinVaultBalance?.data?.totalAmount,
                      )}{" "}
                      {currentCoin} In Vault
                    </p>
                  </div>
                </div>
              </Hidden>
            )}
            <p
              style={{
                textAlign: "left",
                fontSize: "16px",
                color: "#8e8f90",
                fontWeight: "bold",
              }}
            >
              QUANTITY
            </p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                marginBottom: "8px",
                alignItems: "center",
              }}
            >
              <div className={classes.amtInput}>
                <TextField
                  id="amount"
                  fullWidth={true}
                  variant="outlined"
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^0-9.]*/, "");

                    setAmount(val);
                  }}
                  value={amount || ""}
                  error={errorFields.amt}
                  type="number"
                  InputProps={{
                    inputProps: {
                      min: minAmount,
                      max: maxAmount < minAmount ? minAmount : maxAmount,
                      step: Number(
                        1 /
                          Math.pow(
                            10,
                            vaultConfig.data?.find(
                              (ele) => ele.coinId == currentCoin,
                            )?.decimalVault,
                          ),
                      ),
                    },
                  }}
                  required
                  helperText={
                    errorFields.amt ? "Please enter the quantity" : null
                  }
                  className={classes.inputField}
                  placeholder={`Enter ${currentCoin || ""} quantity`}
                />
              </div>

              <div className={classes.interestRate}>
                <p>
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    {
                      filteredCoinData?.[currentCoin]?.["lendData"]?.find(
                        (ele) => ele.tenure === months,
                      )?.rate
                    }
                    %
                  </span>{" "}
                  APY Interest Rate
                </p>
              </div>
            </div>{" "}
            {Boolean(token) && (
              <div
                className="text-left mb-3  flex items-center "
                style={{ opacity: "0.6" }}
              >
                <p className="mr-3">
                  Min:{" "}
                  {toPlainString(
                    vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                      ?.minAmount,
                  )}{" "}
                  {currentCoin}
                </p>{" "}
                <p>
                  Max:{" "}
                  {toPlainString(
                    vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                      ?.maxAmount,
                  )}{" "}
                  {currentCoin}
                </p>
              </div>
            )}
            {Boolean(token) && (
              <div className={classes.percents}>
                <Button
                  disableElevation
                  className={`${classes.percentBox} `}
                  onClick={() => {
                    // const percentage = (
                    //   Number(currentCoinBalance?.data?.[0]?.availableBalance) *
                    //   0.25
                    // ).toFixed(
                    //   vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                    //     ?.decimalVault,
                    // );
                    let decimal = Math.pow(
                      10,
                      vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                        ?.decimalVault,
                    );
                    const percentage =
                      Math.floor(
                        Number(
                          currentCoinBalance?.data?.[0]?.availableBalance *
                            0.25,
                        ) * decimal,
                      ) / decimal;
                    if (percentage == 0) {
                      handleClickAlert("error", "Insufficient balance!");
                    }
                    setAmount(percentage);
                  }}
                >
                  25%
                </Button>
                <Button
                  disableElevation
                  className={classes.percentBox}
                  onClick={() => {
                    // const percentage = (
                    //   Number(currentCoinBalance?.data?.[0]?.availableBalance) *
                    //   0.5
                    // ).toFixed(
                    //   vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                    //     ?.decimalVault,
                    // );
                    let decimal = Math.pow(
                      10,
                      vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                        ?.decimalVault,
                    );
                    const percentage =
                      Math.floor(
                        Number(
                          currentCoinBalance?.data?.[0]?.availableBalance * 0.5,
                        ) * decimal,
                      ) / decimal;
                    if (percentage == 0) {
                      handleClickAlert("error", "Insufficient balance!");
                    }
                    setAmount(percentage);
                  }}
                >
                  50%
                </Button>
                <Button
                  disableElevation
                  className={classes.percentBox}
                  onClick={() => {
                    // const percentage = (
                    //   Number(currentCoinBalance?.data?.[0]?.availableBalance) *
                    //   0.75
                    // ).toFixed(
                    //   vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                    //     ?.decimalVault,
                    // );
                    let decimal = Math.pow(
                      10,
                      vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                        ?.decimalVault,
                    );
                    const percentage =
                      Math.floor(
                        Number(
                          currentCoinBalance?.data?.[0]?.availableBalance *
                            0.75,
                        ) * decimal,
                      ) / decimal;
                    if (percentage == 0) {
                      handleClickAlert("error", "Insufficient balance!");
                    }
                    setAmount(percentage);
                  }}
                >
                  75%
                </Button>
                <Button
                  disableElevation
                  className={classes.percentBox}
                  onClick={() => {
                    let decimal = Math.pow(
                      10,
                      vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                        ?.decimalVault,
                    );
                    const percentage =
                      Math.floor(
                        Number(
                          currentCoinBalance?.data?.[0]?.availableBalance,
                        ) * decimal,
                      ) / decimal;
                    // .toFixed(
                    //   vaultConfig.data?.find((ele) => ele.coinId == currentCoin)
                    //     ?.decimalVault,
                    // );

                    if (percentage == 0) {
                      handleClickAlert("error", "Insufficient balance!");
                    }
                    setAmount(percentage);
                  }}
                >
                  100%
                </Button>
              </div>
            )}
            {Boolean(amount) && amount > 0 && (
              <p
                className="px-2"
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  marginTop: "20px",
                }}
              >
                <>
                  You are locking{" "}
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      wordBreak: "break-all",
                    }}
                  >
                    {amount}
                  </span>{" "}
                  {currentCoin} for {dictMonth[months].replace("Vault", "")}
                  and you will get{" "}
                  <Tooltip
                    className="cursor-pointer"
                    title={interest}
                    placement="top"
                    enterTouchDelay={0}
                    arrow
                  >
                    <span
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    >
                      {truncate(interest)}
                    </span>
                  </Tooltip>{" "}
                  {currentCoin} as interest with an annual percentage yield of{" "}
                  <span style={{ color: theme.palette.primary.main }}>
                    {
                      filteredCoinData?.[currentCoin]?.["lendData"]?.find(
                        (ele) => ele.tenure === months,
                      )?.rate
                    }
                    %.
                  </span>{" "}
                </>
              </p>
            )}
            <Button
              variant="contained"
              type="submit"
              color="primary"
              className="mt-3 normal-case"
              style={{
                borderRadius: "20px",
                width: "100%",
                color: "white",
                fontWeight: "bold",
              }}
              disabled={doubleClick}
            >
              Lock in Vault
            </Button>
          </div>
        </form>
      </div>
      {/* right card*/}

      <div className={`${classes.rightCard} `}>
        <div
          className={`${classes.glassCard}  md:block  ${
            isMobile
              ? currentScreenMobile === "MY_VAULTS"
                ? "block"
                : "hidden"
              : ""
          }`}
          style={{ padding: 0 }}
        >
          <AppBar
            position="static"
            style={{ backgroundColor: "transparent", boxShadow: "none" }}
          >
            <CustomTabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="simple tabs example"
              indicatorColor="primary"
            >
              <StyledTab
                className="normal-case"
                label="Active Vaults"
                {...a11yProps(0)}
              />
              <StyledTab
                className="normal-case"
                label="History"
                {...a11yProps(1)}
              />
            </CustomTabs>
          </AppBar>
          <TabPanel value={tabValue} index={0}>
            {lendOrders.isSuccess ? (
              lendOrders.data?.length !== 0 ? (
                lendOrders.data?.map((vault, idx) => (
                  <Accordion
                    key={vault.id}
                    defaultExpanded={idx == 0 ? true : false}
                    className="rounded-lg overflow-hidden  mb-3 shadow-xl text-xs"
                  >
                    <AccordionSummary
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className="dark:bg-[#353A43] "
                    >
                      <div
                        className="w-full"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <img
                              src={coinIcons[vault.coinId]?.activeIconUrl}
                              height="auto"
                              width={14}
                              className="mr-2"
                              alt={currentCoin}
                            />

                            <div style={{ fontWeight: "bold" }}>
                              {vault.coinId}
                            </div>
                          </div>
                          <div>Token</div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontWeight: "bold" }}>
                            {vault.rate}% APY
                          </p>
                          <p>Interest Rate</p>
                        </div>{" "}
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontWeight: "bold" }}>
                            {dictMonth[vault.tenure].replace("Vault", "")}
                          </p>
                          <p>Duration</p>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontWeight: "bold" }}>
                            {toPlainString(vault.principal)} {vault.coinId}
                          </p>
                          <p>Locked in Vault</p>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        className="w-full py-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontWeight: "bold" }}>
                            {format(new Date(vault.createdAt), "dd MMM, yy")}
                          </p>
                          <p>Start Date</p>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <p style={{ fontWeight: "bold" }}>
                            {format(new Date(vault.maturityDate), "dd MMM, yy")}
                          </p>
                          <p>End Date</p>
                        </div>

                        <div style={{ textAlign: "center" }}>
                          <Tooltip
                            className="cursor-pointer"
                            title={
                              Number(vault.interestEarned) == 0
                                ? 0
                                : toPlainString(vault.interestEarned)
                            }
                            placement="top"
                            enterTouchDelay={0}
                            arrow
                          >
                            <p style={{ fontWeight: "bold" }}>
                              {Number(vault.interestEarned) == 0
                                ? 0
                                : truncate(
                                    toPlainString(vault.interestEarned),
                                  )}{" "}
                            </p>
                          </Tooltip>
                          <p>Interest Earned</p>
                        </div>

                        <div
                          style={{ textAlign: "center" }}
                          className="cursor-pointer"
                        >
                          <div
                            onClick={() =>
                              deleteVaultConfirmationDialog(
                                vault.id,
                                toPlainString(vault.principal),
                                vault.coinId,
                                format(new Date(vault.createdAt), "dd MMM, yy"),
                              )
                            }
                          >
                            <DeleteIcon
                              style={{
                                color: "#E65661",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <p className="text-center">No vaults</p>
              )
            ) : lendOrders.isLoading ? (
              <div style={{ textAlign: "center" }}>
                <img
                  src={loaderGif}
                  alt="loading..."
                  style={{
                    marginTop: "10%",
                    marginBottom: "10%",
                    width: "180px",
                    height: "auto",
                  }}
                />
              </div>
            ) : (
              !Boolean(token) && <LoginOrCreateAccount></LoginOrCreateAccount>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <>
              {historyV ? (
                hVaults.length !== 0 ? (
                  hVaults.map((vault, idx) => (
                    <Accordion
                      defaultExpanded={idx == 0 ? true : false}
                      className="rounded-lg overflow-hidden  mb-3 shadow-xl text-xs"
                      style={
                        vault.status === "CANCELLED"
                          ? {
                              backgroundColor: "rgba(230, 86, 97, 0.4)",
                            }
                          : {
                              backgroundColor:
                                theme.palette.type === "dark"
                                  ? "#204847"
                                  : "#D2F6EB",
                            }
                      }
                    >
                      <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div
                          className="w-full"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={coinIcons[vault.coinId]?.activeIconUrl}
                                height="auto"
                                width={16}
                                className="mr-2"
                                alt={currentCoin}
                              />
                              <p style={{ fontWeight: "bold" }}>
                                {vault.coinId}
                              </p>
                            </div>
                            <p>Token</p>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontWeight: "bold" }}>
                              {vault.rate}% APY
                            </p>
                            <p>Interest Rate</p>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontWeight: "bold" }}>
                              {toPlainString(vault.principal)} {vault.coinId}
                            </p>
                            <p>Principal</p>
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div
                          className="w-full py-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontWeight: "bold" }}>
                              {dictMonth[vault.tenure].replace("Vault", "")}
                            </p>
                            <p>Duration</p>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            {vault.status === "CANCELLED" ? (
                              <p style={{ fontWeight: "bold" }}>
                                {" "}
                                {format(new Date(vault.closedAt), "dd MMM, yy")}
                              </p>
                            ) : (
                              <Tooltip
                                className="cursor-pointer"
                                title={toPlainString(vault.interestEarned)}
                                placement="top"
                                enterTouchDelay={0}
                                arrow
                              >
                                <p style={{ fontWeight: "bold" }}>
                                  {truncate(
                                    toPlainString(vault.interestEarned),
                                  )}
                                </p>
                              </Tooltip>
                            )}{" "}
                            <p>
                              {vault.status === "CANCELLED"
                                ? "Cancelled Date"
                                : "Interest Earned"}
                            </p>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <p style={{ fontWeight: "bold" }}>
                              {format(new Date(vault.createdAt), "dd MMM, yy")}
                            </p>

                            <p>Start Date</p>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))
                ) : (
                  <p className="text-center">No history</p>
                )
              ) : !Boolean(token) ? (
                <LoginOrCreateAccount></LoginOrCreateAccount>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={loaderGif}
                    alt="loading..."
                    style={{
                      marginTop: "10%",
                      marginBottom: "10%",
                      width: "180px",
                      height: "auto",
                    }}
                  />
                </div>
              )}
              {historyV?.last
                ? null
                : Boolean(token) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        paddingTop: "20px",
                        paddingBottom: "10px",
                      }}
                    >
                      <Button
                        onClick={loadMore}
                        variant="outlined"
                        color="primary"
                        style={{ fontWeight: "bold" }}
                      >
                        Load more
                      </Button>
                    </div>
                  )}
            </>
          </TabPanel>
        </div>

        <div
          className={`${classes.glassCard}  md:block  ${
            isMobile
              ? currentScreenMobile === "FAQS"
                ? "block"
                : "hidden"
              : ""
          }`}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "15px",
              alignItems: "center",
            }}
          >
            <p style={{ fontWeight: "bold", fontSize: "18px" }}>FAQ</p>
            <p
              className={classes.link}
              onClick={() => {
                window.open(
                  "https://support.pocketbits.in/support/solutions",
                  "_blank",
                  "nofollow,noopener,noreferrer",
                );
              }}
            >
              View All
            </p>
          </div>
          <div>
            <Accordion className="rounded-lg overflow-hidden  mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="dark:bg-[#353A43] "
              >
                <Typography className={classes.heading}>
                  What is a vault?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="text-sm">
                  The PocketBits Vault is similar to a Fixed Deposit Plan
                  wherein you earn an interest on the crypto by staking it with
                  us for a fixed tenure.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className="rounded-lg overflow-hidden  mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="dark:bg-[#353A43] "
              >
                <Typography className={classes.heading}>
                  Is there a fee for using vault storage?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="text-sm">
                  There is no fee to use the PocketBits Vault. Users can earn
                  interest on their crypto when staking it in the Vault.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className="rounded-lg overflow-hidden  mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="dark:bg-[#353A43] "
              >
                <Typography className={classes.heading}>
                  What happens if I cancel my Vault plan before time?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="text-sm">
                  If you cancel the Vault before the expiry of your tenure, no
                  interest is earned and you will instantly receive the
                  principal crypto back to your PocketBits wallet.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
      <Dialog
        open={openDialogHelp}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">{"Network Fee Note"}</DialogTitle>
        <Divider /> */}
        <DialogContent style={{ marginTop: "15px" }}>
          <DialogContentText id="alert-dialog-description">
            <b>Balance:</b> Your PocketBits {currentCoin} available balance.
            <br />
            <b>Interest Earned:</b> The interest earned on completed{" "}
            {currentCoin} vaults.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose}
            variant="contained"
            color="primary"
            style={{
              marginRight: "10px",
              marginBottom: "10px",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    fill: theme.palette.primary.main,
  },
  paper: {
    marginLeft: "-13px",
  },
  leftCard: {
    [theme.breakpoints.up("md")]: {
      width: "60%",
      float: "left",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: "30px",
    },
  },
  tabRoot: { width: "100%" },

  rightCard: {
    [theme.breakpoints.up("md")]: {
      width: "38%",
      float: "right",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  amtInput: {
    [theme.breakpoints.up("md")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  percents: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "20px",
  },
  interestRate: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "4px",
    },
    fontSize: "16px",
  },
  dropBalance: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    width: "100%",

    // alignItems: "center",
  },
  coinHolder: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
  },
  wrapper: {
    marginBottom: "25px",
    borderRadius: "25px !important",
    overflow: "hidden",
    boxShadow:
      theme.palette.type === "dark"
        ? "none !important"
        : "2px 7px 8px rgba(0, 0, 0, 0.15);",
    lineHeight: "25px",
    background: theme.palette.type === "dark" ? "#2D2F3E" : "white",
    // minWidth: "450px",
  },
  infobarStyles: {
    width: "100%",
    // height: "73px",
    display: "flex",
    flexDirection: "row",
    flex: 1,
    justifyContent: "space-between",
    paddingLeft: "12px",
    paddingRight: "12px",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "5px",
      paddingTop: "5px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "10px",
      paddingBottom: "10px",
      alignItems: "top",
    },
  },
  coinName: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  highlow: {
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
    alignItems: "baseline",
  },
  infoHeaderStyles: {
    color: theme.palette.text.primary,
    opacity: 0.7,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginRight: "5px",
      marginLeft: "10px",
    },
    fontSize: "13px",
    marginRight: "5px",
  },
  declineStyles: {
    color: theme.palette.error.light,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  growthStyles: {
    color: theme.palette.success.main,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  defaultStyles: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginLeft: "10px",
    },
    fontSize: "16px",
  },
  coinCard: {
    // margin: "0px 10px",
    margin: "10px 0px",
    maxWidth: "100px",
    display: "flex",
    alignItems: "center",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#FFFFFF",
    // boxShadow:
    //   theme.palette.type === "dark"
    //     ? "40px 60px 200px rgba(16, 18, 26, 0.5)"
    //     : "0px 4px 8px rgba(0, 0, 0, 0.12)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    borderRadius: "12px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  glassCard: {
    overflow: "hidden",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#FFFFFF",
    boxShadow:
      theme.palette.type === "dark" ? "" : "2px 4px 8px rgba(0, 0, 0, 0.16)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    // width: "35%",
    borderRadius: "25px",
    padding: "20px",
    marginBottom: "30px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  vaultCard: {
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#ffffff",
    boxShadow:
      theme.palette.type === "dark"
        ? "none"
        : "2px 4px 8px rgba(0, 0, 0, 0.16)",
    borderRadius: "24px",
    padding: "20px",
    margin: "25px 0px",
    textAlign: "center",
    // transform: "rotate(180deg)"
  },
  vaultCoin: {
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "#ffffff",
    boxShadow:
      theme.palette.type === "dark"
        ? "none"
        : "2px 4px 8px rgba(0, 0, 0, 0.16)",
    borderRadius: "24px",
  },

  inputField: {
    backgroundColor: theme.palette.type === "dark" ? "#1B202D" : "#FFFFFF",
    boxShadow:
      theme.palette.type === "dark"
        ? "inset 4.86282px 4.86282px 4.86282px rgba(0, 0, 0, 0.25)"
        : "inset 2px 6px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: theme.palette.type === "dark" ? "10px !important" : "4px",
  },
  percentBox: {
    marginBottom: "10px",
    marginRight: "10px",
    background:
      theme.palette.type === "dark" ? "rgba(87, 87, 87, 0.33)" : "#eee",

    borderRadius: "6.75px",
    fontWeight: 500,
    fontSize: "15.75px",
    // color: "#FAFAFA",
    padding: "8px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
  arrow: {
    "&:hover": {
      // background: "#F5F5F5",
      // background: '#585858'
      // background: theme.palette.type !== "light" ? "#585858" : "#F5F5F5",
      cursor: "pointer",
    },
  },
  scrollWrapper: {
    overflow: "hidden",
    userSelect: "none",
    paddingBottom: "30px",
    paddingTop: "30px",
  },
  innerScrollWrapper: {
    marginLeft: "-54px",
  },
}));

const CustomTabs = withStyles((theme) => ({
  root: {
    // borderTopLeftRadius: "25px",
    // borderTopRightRadius: "25px",
    boxShadow: "none !important",
    backgroundColor: "transparent",
    borderBottomStyle: theme.palette.type === "dark" ? null : "solid",
    borderColor: theme.palette.type === "dark" ? "#262B3A" : "#ffffff",
    borderWidth: "1px",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 3.5,
    "& > div": {
      width: "60%",
      borderRadius: "25px",
      backgroundColor: theme.palette.primary.main,
    },
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    minWidth: "50%",
  },
  selected: { color: theme.palette.text.primary },
}))((props) => <Tab {...props} />);
